const awsAuthConfig = {
    domain: process.env.REACT_APP_COGNITO_DOMAIN,
    scope: ["openid", "aws.cognito.signin.user.admin"],
    redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN_URI,
    redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGNOUT_URI,
    responseType: "code",
};

export default awsAuthConfig;
